function addSpacesToClosingTags(inputString: string) {
  const closingTagPattern = /<\/\w+>/g;
  return inputString.replace(closingTagPattern, (match) => `${match} `);
}

export function applyVariableLabelToSpan(originalBody: string): string {
  return originalBody.replace(
    /<span([^>]*)class="custom-variable-chip"([^>]*)>(.*?)<\/span>/gi,
    (_match, beforeClass, afterClass, innerContent) => {
      // Combine all attributes
      const attributes = `${beforeClass}class="custom-variable-chip"${afterClass}`;
      // Find the label attribute value
      const labelMatch = attributes.match(/label="([^"]*)"/i);
      const labelValue = labelMatch ? labelMatch[1] : innerContent;
      return `<span${attributes}>${labelValue}</span>`;
    },
  );
}

export function getTextFromHtml(
  html: string,
  options?: { convertVariables?: boolean },
): string {
  let newHtml = addSpacesToClosingTags(html);
  if (options?.convertVariables) {
    newHtml = applyVariableLabelToSpan(newHtml);
  }
  const doc = new DOMParser().parseFromString(newHtml, 'text/html');
  return doc.body.textContent || '';
}
